<div
  class="card"
  [ngClass]="{
    'vertical-card': isVertical,
    'horizontal-card': !isVertical,
    'face-up': isFaceUp,
    'pointer': isSelectable,
    'highlight': shouldHighlight
  }"
>
  <div *ngIf="isFaceUp">
    <span class="rank">{{ card.rankSymbol }}</span
    >{{ card.suiteSymbol }}
  </div>
</div>
